import {
    FETCH_NUMBER_OF_ACTIVE_PLAYERS,
    FETCH_NUMBER_OF_ACTIVE_PLAYERS_FAIL,
    FETCH_NUMBER_OF_ACTIVE_PLAYERS_SUCCESS,
    FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY,
    FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_FAIL,
    FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_SUCCESS,
    FETCH_NUMBER_OF_PLAYERS,
    FETCH_NUMBER_OF_PLAYERS_FAIL,
    FETCH_NUMBER_OF_PLAYERS_SUCCESS,
    FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS,
    FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_FAIL,
    FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_SUCCESS,
    FETCH_OPEN_ALERTS_PER_RULE_CATEGORY,
    FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_FAIL,
    FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_SUCCESS,
    FETCH_OVERALL_SYSTEM_RISK,
    FETCH_OVERALL_SYSTEM_RISK_FAIL,
    FETCH_OVERALL_SYSTEM_RISK_SUCCESS,
    FETCH_REGISTRATIONS_PER_MONTH,
    FETCH_REGISTRATIONS_PER_MONTH_FAIL,
    FETCH_REGISTRATIONS_PER_MONTH_SUCCESS,
    FETCH_STATS,
    FETCH_STATS_FAIL,
    FETCH_STATS_SUCCESS,
    FETCH_TOP_RISKY_PLAYERS,
    FETCH_TOP_RISKY_PLAYERS_FAIL,
    FETCH_TOP_RISKY_PLAYERS_SUCCESS,
    FETCH_WORLDMAP,
    FETCH_WORLDMAP_FAIL,
    FETCH_WORLDMAP_SUCCESS
} from './actionTypes';

export const fetchStats = (payload) => ({
    type: FETCH_STATS,
    payload
});
export const fetchStatsSuccess = payload => ({
    type: FETCH_STATS_SUCCESS,
    payload
});
export const fetchStatsFail = payload => ({
    type: FETCH_STATS_FAIL,
    payload
});

export const fetchWorldmap = payload => ({
    type: FETCH_WORLDMAP,
    payload
});
export const fetchWorldmapSuccess = payload => ({
    type: FETCH_WORLDMAP_SUCCESS,
    payload
});
export const fetchWorldmapFail = payload => ({
    type: FETCH_WORLDMAP_FAIL,
    payload
});
export const fetchNumberOfPlayers = payload => ({
    type: FETCH_NUMBER_OF_PLAYERS,
    payload
});
export const fetchNumberOfPlayersSuccess = payload => ({
    type: FETCH_NUMBER_OF_PLAYERS_SUCCESS,
    payload
});
export const fetchNumberOfPlayersFail = payload => ({
    type: FETCH_NUMBER_OF_PLAYERS_FAIL,
    payload
});
export const fetchNumberOfPlayersWithOpenAlerts = payload => ({
    type: FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS,
    payload
});
export const fetchNumberOfPlayersWithOpenAlertsSuccess = payload => ({
    type: FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_SUCCESS,
    payload
});
export const fetchNumberOfPlayersWithOpenAlertsFail = payload => ({
    type: FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS_FAIL,
    payload
});
export const fetchNumberOfActivePlayers = payload => ({
    type: FETCH_NUMBER_OF_ACTIVE_PLAYERS,
    payload
});
export const fetchNumberOfActivePlayersSuccess = payload => ({
    type: FETCH_NUMBER_OF_ACTIVE_PLAYERS_SUCCESS,
    payload
});
export const fetchNumberOfActivePlayersFail = payload => ({
    type: FETCH_NUMBER_OF_ACTIVE_PLAYERS_FAIL,
    payload
});

export const fetchNumberOfEventsForTheLastDay = payload => ({
    type: FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY,
    payload
});

export const fetchNumberOfEventsForTheLastDaySuccess = payload => ({
    type: FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_SUCCESS,
    payload
});

export const fetchNumberOfEventsForTheLastDayFail = payload => ({
    type: FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY_FAIL,
    payload
});

export const fetchTopRiskyPlayers = payload => ({
    type: FETCH_TOP_RISKY_PLAYERS,
    payload
});

export const fetchTopRiskyPlayersSuccess = payload => ({
    type: FETCH_TOP_RISKY_PLAYERS_SUCCESS,
    payload
});

export const fetchTopRiskyPlayersFail = payload => ({
    type: FETCH_TOP_RISKY_PLAYERS_FAIL,
    payload
});
export const fetchRegistrationsPerMonth = payload => ({
    type: FETCH_REGISTRATIONS_PER_MONTH,
    payload
});

export const fetchRegistrationsPerMonthSuccess = payload => ({
    type: FETCH_REGISTRATIONS_PER_MONTH_SUCCESS,
    payload
});

export const fetchRegistrationsPerMonthFail = payload => ({
    type: FETCH_REGISTRATIONS_PER_MONTH_FAIL,
    payload
});
export const fetchOverallSystemRisk = payload => ({
    type: FETCH_OVERALL_SYSTEM_RISK,
    payload
});

export const fetchOverallSystemRiskSuccess = payload => ({
    type: FETCH_OVERALL_SYSTEM_RISK_SUCCESS,
    payload
});

export const fetchOverallSystemRiskFail = payload => ({
    type: FETCH_OVERALL_SYSTEM_RISK_FAIL,
    payload
});
export const fetchOpenAlertsPerRuleCategory = payload => ({
    type: FETCH_OPEN_ALERTS_PER_RULE_CATEGORY,
    payload
});

export const fetchOpenAlertsPerRuleCategorySuccess = payload => ({
    type: FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_SUCCESS,
    payload
});

export const fetchOpenAlertsPerRuleCategoryFail = payload => ({
    type: FETCH_OPEN_ALERTS_PER_RULE_CATEGORY_FAIL,
    payload
});
